export const mixins = {
  methods: {
    tableRowClassName({row}) {
      if (row.black_status === 1) {
        return `warning-row`;
      }
      return '';
    },
  },
}